import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { IndicatorBase } from '../IndicatorBase/IndicatorBase.js';
import { ANGLE_360 } from '../IndicatorBase/constants.js';
import { ProgressStyle } from './Progress.styles.js';

const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
const _Progress = forwardRef((props, ref) => {
    const { color, max, min, style, track, // Used only in ProgressStyle, prevent passing it to DOM
    value, ...rest } = props;
    const range = max - min;
    const strokeAngle = ((clamp(value, min, max) - min) / range) * ANGLE_360;
    return (React.createElement(IndicatorBase, { "aria-valuemin": min, "aria-valuemax": max, "aria-valuenow": value, primaryProps: { strokeAngle }, style: { color, ...style }, ...rest, ref: ref }));
});
_Progress.displayName = '_Progress';
const defaultProps = {
    min: 0,
    max: 100,
    size: 'small',
    track: true,
    value: 0,
};
const Progress = styled(_Progress) `
    ${ProgressStyle}
`;
Progress.defaultProps = defaultProps;

export { Progress };
//# sourceMappingURL=Progress.js.map
